import { defineStore } from 'pinia';

export interface PageStateInterface { // 页面状态
}

/**
 * 页面数据
 */
export default defineStore('page', {
  state: (): PageStateInterface => { // 状态
    return {};
  },
  getters: { // 获取
  },
  actions: { // 方法
  }
});